import { FactorData } from "types/factor/factor";

import hasActiveMatchingPhoneNumbers from "./hasActiveMatchingPhoneNumbers";

const isValidForFactorRemoval = (factorData: FactorData): boolean => {
  const activeFactorsCount = Object.values(factorData.factorMap).filter(
    (factor) => factor.flags.isActive,
  ).length;

  return (
    activeFactorsCount > 1 &&
    !(
      // Condition where the only 2 active factors are phone factors with matching phone numbers
      // Can't allow removal in this case, because removing 1 will remove both
      (
        activeFactorsCount === 2 &&
        hasActiveMatchingPhoneNumbers(factorData.factorMap)
      )
    )
  );
};

export default isValidForFactorRemoval;
